'use client';

import dynamic from 'next/dynamic';

/**
 * Client-side dynamic wrapper around `ProductImagesGrid` — the digital-
 * landing extra-images masonry strip rendered below the description.
 *
 * Deferred because it's below the fold (no first-paint benefit) and the
 * heaviest single hydration cost on the PDP (a `requestAnimationFrame`
 * auto-scroll loop). `dynamic({ ssr: false })` keeps it off the critical
 * hydration pass; the `loading` placeholder reserves the ~352px slot so
 * the real grid drops into pre-reserved space (no CLS spike).
 *
 * A separate `'use client'` file is required because `dynamic({ ssr:
 * false })` can't be called from the Server Component that renders it.
 */
const ProductImagesGrid = dynamic(
  () =>
    import('./ProductImagesGrid').then(mod => ({
      default: mod.ProductImagesGrid,
    })),
  {
    ssr: false,
    loading: () => (
      <section aria-hidden className="px-4">
        <div className="mb-4 h-6 w-40 rounded bg-zinc-200" />
        <div className="flex h-[308px] gap-2 pb-1">
          <div className="h-full w-[150px] shrink-0 rounded bg-zinc-200" />
          <div className="h-full w-[150px] shrink-0 rounded bg-zinc-200" />
        </div>
      </section>
    ),
  },
);

export { ProductImagesGrid as LazyProductImagesGrid };
